import { MessageModalProps } from "core/utils/modals";
import { ExclamationTriangle } from "react-bootstrap-icons";
import { PrimaryButton } from "../../buttons/buttons";
import Modal from "../modal/modal";

const footer = (close: VoidFunction) => (
	<PrimaryButton onClick={close}>Aceptar</PrimaryButton>
);

export const ErrorModal = (props: MessageModalProps) => {
	return (
		<Modal parent={props.parent} footer={footer} onClosed={props.onClosed}>
			<div className="text-center">
				<ExclamationTriangle className="modal-icon" /><br />
				<strong>{props.message}</strong>
			</div>
		</Modal>
	);
};

export default ErrorModal;